export enum InspectionStatus {
  Solicitacao = 0,
  AguardandoDirecionamento = 1,
  AguardandoAceitePrestadora = 2,
  AguardandoAceiteInspetor = 3,
  AceitaInspetor = 4,
  Agendada = 5,
  EmExecucao = 6,
  AguardandoEnvioDados = 7,
  AguardandoRevisaoInspecao = 8,
  Aprovada = 9,
  DevolvidaParaAjustes = 10,
  Concluida = 11,
  Cancelada = 12,
  RejeitadaPrestadora = 13,
  Frustrada = 14
}

export enum InspectionItemStatus {
  AguardandoDirecionamento = 0,
  AguardandoAceitePrestadora = 1,
  PrestadoraRecusou = 2,
  AguardandoDirecionamentoInspetor = 3,
  AguardandoAceiteInspetor = 4,
  InspetorRecusou = 5,
  AguardandoAgendamento = 6,
  Agendado = 7,
  CheckinRealizado = 8,
  Finalizado = 9,
  Cancelado = 10,
  Frustrado = 11,
  // Fluxo de revisão de laudos (ordem lógica)
  AguardandoGeracaoLaudo = 12,        // Checklist realizado, aguardando gerar laudo
  AguardandoRevisaoPrestadora = 13,   // Laudo gerado, prestadora revisa
  LaudoNegadoPorPrestadora = 14,      // Prestadora negou o laudo
  AguardandoRevisaoBanco = 15,        // Prestadora aprovou, banco revisa
  LaudoNegadoPorBanco = 16,           // Banco negou o laudo
  CorrecaoPeloInspetorBanco = 17,     // Inspetor do banco está corrigindo
  LaudoAceitoPeloBanco = 18,          // Banco aprovou (final)

  // Fluxo de televistoria
  TelevistoriaAgendada = 19,          // Televistoria (videoconferência) foi agendada
  TelevistoriaFinalizada = 20,        // Televistoria finalizada, aguardando gerar laudo

  // Laudo Automático (sem inspetor)
  LaudoDevolvido = 21,                // Laudo devolvido para correção
  AguardandoPreenchimentoPrestadora = 22,  // Prestadora preenche diretamente (sem inspetor)

  // Fluxo de Laudo Automático (IA)
  ProcessandoScraping = 23,           // Scraping em andamento
  AguardandoAnaliseIA = 24,           // Scraping concluído, aguardando IA
  ProcessandoAnaliseIA = 25,          // IA processando
  LaudoAutomaticoGerado = 26,         // Laudo automático gerado com sucesso
  ScrapingFalhou = 27,                // Scraping falhou
  AnaliseIAFalhou = 28,               // Análise IA falhou

  // Fluxo de Cálculos Separados
  AguardandoCalculosPrestadora = 29,
  DevolvidoPeloBancoAposAceite = 30,
  DevolvidoPelaPrestadora = 31,

  // Laudo automático (AVM) preenchido pelo próprio banco, sem prestadora
  // (usado enquanto o pipeline de scraping/IA está desativado)
  AguardandoPreenchimentoBanco = 32
}

export enum AssignmentStatus {
  PendingInspectorAcceptance = 0,
  AcceptedByInspector = 1,
  RejectedByInspector = 2,
  Cancelled = 3
}

export const InspectionItemStatusLabels: Record<InspectionItemStatus, string> = {
  [InspectionItemStatus.AguardandoDirecionamento]: "Aguardando Direcionamento",
  [InspectionItemStatus.AguardandoAceitePrestadora]: "Aguardando Aceite da Prestadora",
  [InspectionItemStatus.PrestadoraRecusou]: "Prestadora Recusou",
  [InspectionItemStatus.AguardandoDirecionamentoInspetor]: "Aguardando Direcionamento Inspetor",
  [InspectionItemStatus.AguardandoAceiteInspetor]: "Aguardando Aceite do Inspetor",
  [InspectionItemStatus.InspetorRecusou]: "Inspetor Recusou",
  [InspectionItemStatus.AguardandoAgendamento]: "Aguardando Agendamento",
  [InspectionItemStatus.Agendado]: "Agendado",
  [InspectionItemStatus.CheckinRealizado]: "Checkin Realizado",
  [InspectionItemStatus.Finalizado]: "Aguardando Revisão do Laudo (PRESTADORA)",
  [InspectionItemStatus.Cancelado]: "Cancelado",
  [InspectionItemStatus.Frustrado]: "Frustrado",
  [InspectionItemStatus.LaudoNegadoPorPrestadora]: "Laudo Negado por Prestadora",
  [InspectionItemStatus.AguardandoRevisaoBanco]: "Aguardando Revisão do Laudo (BANCO)",
  [InspectionItemStatus.LaudoNegadoPorBanco]: "Laudo Negado pelo Banco",
  [InspectionItemStatus.LaudoAceitoPeloBanco]: "Laudo Aceito pelo Banco",
  [InspectionItemStatus.AguardandoRevisaoPrestadora]: "Aguardando Revisão do Laudo (PRESTADORA)",
  [InspectionItemStatus.CorrecaoPeloInspetorBanco]: "Correção pelo Inspetor (BANCO)",
  [InspectionItemStatus.AguardandoGeracaoLaudo]: "Aguardando Geração do Laudo (legacy)",
  [InspectionItemStatus.TelevistoriaAgendada]: "Televistoria Agendada",
  [InspectionItemStatus.TelevistoriaFinalizada]: "Televistoria Finalizada",
  [InspectionItemStatus.LaudoDevolvido]: "Laudo Devolvido",
  [InspectionItemStatus.AguardandoPreenchimentoPrestadora]: "Aguardando Preenchimento (PRESTADORA)",
  [InspectionItemStatus.ProcessandoScraping]: "Processando Scraping",
  [InspectionItemStatus.AguardandoAnaliseIA]: "Aguardando Análise IA",
  [InspectionItemStatus.ProcessandoAnaliseIA]: "Processando Análise IA",
  [InspectionItemStatus.LaudoAutomaticoGerado]: "Laudo Automático Gerado",
  [InspectionItemStatus.ScrapingFalhou]: "Scraping Falhou",
  [InspectionItemStatus.AnaliseIAFalhou]: "Análise IA Falhou",
  [InspectionItemStatus.AguardandoCalculosPrestadora]: "Aguardando Cálculos da Prestadora",
  [InspectionItemStatus.DevolvidoPeloBancoAposAceite]: "Devolvido pelo Banco (Pós-Aceite)",
  [InspectionItemStatus.DevolvidoPelaPrestadora]: "Devolvido pela Prestadora",
  [InspectionItemStatus.AguardandoPreenchimentoBanco]: "Aguardando Preenchimento (BANCO)"
};

export const InspectionItemStatusColors: Record<InspectionItemStatus, string> = {
  [InspectionItemStatus.AguardandoDirecionamento]: "#ffa500",
  [InspectionItemStatus.AguardandoAceitePrestadora]: "#1890ff",
  [InspectionItemStatus.PrestadoraRecusou]: "#ff4d4f",
  [InspectionItemStatus.AguardandoDirecionamentoInspetor]: "#722ed1",
  [InspectionItemStatus.AguardandoAceiteInspetor]: "#52c41a",
  [InspectionItemStatus.InspetorRecusou]: "#ff4d4f",
  [InspectionItemStatus.AguardandoAgendamento]: "#faad14",
  [InspectionItemStatus.Agendado]: "#13c2c2",
  [InspectionItemStatus.CheckinRealizado]: "#eb2f96",
  [InspectionItemStatus.Finalizado]: "#1890ff",
  [InspectionItemStatus.Cancelado]: "#f5222d",
  [InspectionItemStatus.Frustrado]: "#d4380d",
  [InspectionItemStatus.LaudoNegadoPorPrestadora]: "#fa8c16",
  [InspectionItemStatus.AguardandoRevisaoBanco]: "#722ed1",
  [InspectionItemStatus.LaudoNegadoPorBanco]: "#ff4d4f",
  [InspectionItemStatus.LaudoAceitoPeloBanco]: "#52c41a",
  [InspectionItemStatus.AguardandoRevisaoPrestadora]: "#1890ff",
  [InspectionItemStatus.CorrecaoPeloInspetorBanco]: "#faad14",
  [InspectionItemStatus.AguardandoGeracaoLaudo]: "#eb2f96",
  [InspectionItemStatus.TelevistoriaAgendada]: "#722ed1",
  [InspectionItemStatus.TelevistoriaFinalizada]: "#13c2c2",
  [InspectionItemStatus.LaudoDevolvido]: "#fa8c16",
  [InspectionItemStatus.AguardandoPreenchimentoPrestadora]: "#f59e0b",
  [InspectionItemStatus.ProcessandoScraping]: "#1890ff",
  [InspectionItemStatus.AguardandoAnaliseIA]: "#722ed1",
  [InspectionItemStatus.ProcessandoAnaliseIA]: "#722ed1",
  [InspectionItemStatus.LaudoAutomaticoGerado]: "#52c41a",
  [InspectionItemStatus.ScrapingFalhou]: "#ff4d4f",
  [InspectionItemStatus.AnaliseIAFalhou]: "#ff4d4f",
  [InspectionItemStatus.AguardandoCalculosPrestadora]: "#e040fb",
  [InspectionItemStatus.DevolvidoPeloBancoAposAceite]: "#fa541c",
  [InspectionItemStatus.DevolvidoPelaPrestadora]: "#fa8c16",
  [InspectionItemStatus.AguardandoPreenchimentoBanco]: "#2f54eb"
};

export enum InspectionStatusEvent {
  DIRECIONAR = "DIRECIONAR",
  ACEITAR_PRESTADORA = "ACEITAR_PRESTADORA",
  REJEITAR_PRESTADORA = "REJEITAR_PRESTADORA",
  DIRECIONAR_INSPETOR = "DIRECIONAR_INSPETOR",
  ACEITAR_INSPETOR = "ACEITAR_INSPETOR",
  REJEITAR_INSPETOR = "REJEITAR_INSPETOR",
  AGENDAR = "AGENDAR",
  REALIZAR_CHECKIN = "REALIZAR_CHECKIN",
  FINALIZAR = "FINALIZAR",
  CANCELAR = "CANCELAR",
  FRUSTRAR = "FRUSTRAR",
  ENVIAR_PARA_REVISAO_BANCO = "ENVIAR_PARA_REVISAO_BANCO",
  ENCAMINHAR_CALCULOS = "ENCAMINHAR_CALCULOS",
  ENVIAR_CALCULOS_PARA_BANCO = "ENVIAR_CALCULOS_PARA_BANCO"
}

export const InspectionStatusEventLabels: Record<InspectionStatusEvent, string> = {
  [InspectionStatusEvent.DIRECIONAR]: "Direcionar para prestadora",
  [InspectionStatusEvent.ACEITAR_PRESTADORA]: "Prestadora aceitar inspeção",
  [InspectionStatusEvent.REJEITAR_PRESTADORA]: "Prestadora rejeitar inspeção", 
  [InspectionStatusEvent.DIRECIONAR_INSPETOR]: "Direcionar para inspetor",
  [InspectionStatusEvent.ACEITAR_INSPETOR]: "Inspetor aceitar inspeção",
  [InspectionStatusEvent.REJEITAR_INSPETOR]: "Inspetor rejeitar inspeção",
  [InspectionStatusEvent.AGENDAR]: "Agendar inspeção",
  [InspectionStatusEvent.REALIZAR_CHECKIN]: "Realizar checkin",
  [InspectionStatusEvent.FINALIZAR]: "Finalizar inspeção",
  [InspectionStatusEvent.CANCELAR]: "Cancelar inspeção",
  [InspectionStatusEvent.FRUSTRAR]: "Frustrar inspeção",
  [InspectionStatusEvent.ENVIAR_PARA_REVISAO_BANCO]: "Enviar para revisão do Banco",
  [InspectionStatusEvent.ENCAMINHAR_CALCULOS]: "Encaminhar cálculos para prestadora",
  [InspectionStatusEvent.ENVIAR_CALCULOS_PARA_BANCO]: "Enviar cálculos para o banco"
};
